<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-delete @deleteSelection="deleteSelection" />
        <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" />
        <button-export
          :href="exportMbUrl"
          download="download.xls"
          :beforeDownload="beforeDownloadMB"
          value="模板下载"/>
      </div>
    <div style="display: flex;justify-content: space-between">
      <input-search  placeholder="住户名称/房间号"  @search="searchKey" />
    </div>
      </div>
    <div class="search-line">
      <div class="btn-box">
      <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">更新时间</span>
        <el-date-picker v-model="timevalue"  size="small" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" @deleteLine="deleteLine"></table-main>

    <el-dialog
      title="修改"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">住户名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">房间号：</span>
        </div>
        <el-input v-model="formData.roomInfoName" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物业缴费面积：</span>
        </div>
        <el-input v-model="formData.proprtyArea" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">年用电费额度：</span>
        </div>
        <el-input v-model="formData.yearElectricityQuota" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">超额用电单价：</span>
        </div>
        <el-input v-model="formData.overPrice" size="small" style="width: 280px" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button type="primary" size="small" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nError, nSuccess, nAlert } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "electricity-quota",
  data() {
    return {
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "物业费台账"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "roomInfoName",
          label: "房间号"
        },
        {
          prop: "proprtyArea",
          label: "物业缴费面积(m²)"
        },
        {
          prop: "yearElectricityQuota",
          label: "年用电额度(度)"
        },
        {
          prop: "overPrice",
          label: "超额用电单价(元)"
        },
        {
          prop: "updateTime",
          label: "更新时间"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      exportUrl: "",
      requestData: {
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      timevalue: [],
      uploadUrl: "",
      dialogVisible: false,
      formData: {},
      selectionArr: [],
      exportMbUrl: ""
    };
  },
  created() {
    this.getCreateTime();
    this.uploadUrl = api.importElectricityQuota;
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportApply}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }`;
    },
    beforeDownloadMB() {
      this.exportMbUrl = `${api.exportMbUrl}`;
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getNiceElectricityQuotaPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            v.changeInputDisabled = true;
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.dialogVisible = true;
      this.$axios
        .post(`${api.getElectricityQuotaByCode}/${code}`, {})
        .then(res => {
          this.formData = res.data.data;
        })
        .catch(errorHandler("用电配额查询失败"));
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的选项");
        return false;
      } else {
        this.$confirm("是否确认删除该选项？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    search(v) {},
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },

    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      if (!this.formData.proprtyArea) {
        nError("请输入物业缴费面积");
        return false;
      }
      if (!this.formData.yearElectricityQuota) {
        nError("请输入年用电费额度");
        return false;
      }
      if (!this.formData.overPrice) {
        nError("请输入超额用电单价");
        return false;
      }
      this.$axios
        .post(api.updateElectricityQuota, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.getPage();
          }
        })
        .catch(errorHandler("修改失败"));
      this.dialogVisible = false;
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteElectricityQuota, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/PropertyFeeManagement/ElectricityQuota.vue